import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DotsStrip from "./dotsStrip";

const TOKENS = {
  radius: 5,
  stroke: "#E9E9E9",
  panel: "#FFFFFF",
  dotActive: "#E5007E",
  dotIdle: "#DADADA",
  text: "#111111",
};

export default function ImageNavigationControls({
  onPrev,
  onNext,
  currentIndex = 0,
  totalItems = 1,
}) {
  const renderDots = () => {
    return <DotsStrip cur={currentIndex} count={totalItems} />;
    
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          marginBottom: "12px",
          marginTop: 0,
        }}
      >
        {Array.from({ length: totalItems }).map((_, i) => (
          <Box
            key={i}
            sx={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              background: i === currentIndex ? TOKENS.dotActive : TOKENS.dotIdle,
              transition: "background 0.23s",
            }}
          />
        ))}
      </Box>
    );
  };

  return (
    <Box
      sx={{
        width: { xs: 28, sm: 32, md: 36, lg: 40 },
        height: {
          xs: "clamp(120px, 24vh, 160px)",
          md: "clamp(140px, 26vh, 176px)",
        },
        alignSelf: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        py: { xs: 0.5, md: 1 },
        gap: { xs: 0.5, md: 1 },
      }}
    >
      {/* Previous Button */}
      <IconButton
        onClick={onPrev}
        sx={{
          bgcolor: TOKENS.panel,
          width: { xs: 34, md: 40 },
          height: { xs: 34, md: 40 },
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.25s ease",
          boxShadow: 0,
          "&:hover": {
            bgcolor: "#FFFFFF",
            boxShadow: "0px 3px 8px rgba(0,0,0,0.18)",
          },
          "&:hover svg": {
            color: "#E5007E",
          },
        }}
      >
        <ArrowBackIcon
          sx={{
            fontSize: { xs: 12, md: 16 },
            color: "#000000",
            transition: "color 0.25s",
          }}
        />
      </IconButton>

      {/* Dots */}
      {renderDots()}

      {/* Next Button */}
      <IconButton
        onClick={onNext}
        sx={{
          bgcolor: TOKENS.panel,
          width: { xs: 34, md: 40 },
          height: { xs: 34, md: 40 },
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.25s ease",
          boxShadow: 0,
          "&:hover": {
            bgcolor: "#FFFFFF",
            boxShadow: "0px 3px 8px rgba(0,0,0,0.18)",
          },
          "&:hover svg": {
            color: "#E5007E",
          },
        }}
      >
        <ArrowForwardIcon
          sx={{
            fontSize: { xs: 12, md: 16 },
            color: "#000000",
            transition: "color 0.25s",
          }}
        />
      </IconButton>
    </Box>
  );
}
